import React from 'react';
import styled from 'styled-components';
import { Dialog } from '@mui/material';
import { Button, colors } from '@leapeasy/ui-kit';

import SuccessIcon from 'assets/dispute_success_icon.svg';

export const DisputeSuccessModal = ({ open, onClose, hasClaimFiledReason }) => {
  return (
    <Dialog open={open} onClose={onClose} scroll="body" maxWidth="xs">
      <CancelContainer col1={colors.purple[900]} col2={colors.neutral[900]}>
        <img src={SuccessIcon} alt="Dispute success" />
        <p>Dispute successfully sent to Leap!</p>
        <p>The disputed icon will turn green when the invoice has been updated.</p>
        {hasClaimFiledReason ? (
          <p>
            If you haven&apos;t already filed a claim for the lines with reason &quot;Claim
            Filed&quot;, please do so here{' '}
            <a href="https://www.leapeasy.com/claim-form" target="_blank" rel="noopener noreferrer">
              www.leapeasy.com/claim-form
            </a>
          </p>
        ) : null}
        <div>
          <Button size="medium" variant="primary" style={{ flexShrink: 2 }} onClick={onClose}>
            Ok
          </Button>
        </div>
      </CancelContainer>
    </Dialog>
  );
};

const CancelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  width: 350px;
  text-align: center;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  & > p:nth-of-type(1) {
    color: ${(props) => props.col1};
    font-size: 14px;
    font-weight: 600;
  }

  & > p:nth-of-type(2) {
    color: ${(props) => props.col2};
    font-size: 12px;
    font-weight: 400;
  }

  & > div {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;

    button {
      flex: 1;
    }
  }
`;
